import React from "react";
import classnames from "classnames";
import styles from "./ToolBarNavDivider.module.scss";
import Divider from "../../Divider/Divider";

interface ToolBarNavDividerProps {
  className?: string;
}

const ToolBarNavDivider = ({ className }: ToolBarNavDividerProps) => {
  return (
    <>
      <div className={classnames(className, styles.root)}></div>
      <Divider className={styles.divider} />
    </>
  );
};

export default ToolBarNavDivider;
